import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Dropdown with a preset list + "Other (Specify)" that reveals a text input.
 * Stores a single string. When user picks a preset, value = preset label.
 * When user picks Other, value = whatever they type.
 */
export default function CategoryField({ value, onChange, options, placeholder = "Select...", testId }) {
  const derivedOther = !!value && !options.includes(value);
  const [otherPicked, setOtherPicked] = React.useState(false);
  const isOther = otherPicked || derivedOther;
  const selectValue = isOther ? "Other" : (value || "");

  return (
    <>
      <Select
        value={selectValue}
        onValueChange={(v) => {
          if (v === "Other") {
            setOtherPicked(true);
            if (!derivedOther) onChange("");
          } else {
            setOtherPicked(false);
            onChange(v);
          }
        }}
      >
        <SelectTrigger className="sharp mt-1 h-10" data-testid={testId}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((p) => (
            <SelectItem key={p} value={p}>{p}</SelectItem>
          ))}
          <SelectItem value="Other">Other (Specify)</SelectItem>
        </SelectContent>
      </Select>
      {isOther && (
        <Input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Please specify"
          className="sharp mt-2 apex-input"
          data-testid={testId ? `${testId}-other` : undefined}
        />
      )}
    </>
  );
}
